<script setup lang="ts">
import Logo from './Logo.vue';
</script>

<template>
  <div class="d-flex flex-row align-center justify-space-between">
    <logo :primary="true"></logo>
    <slot></slot>
  </div>
</template>
